import { createApi } from '@reduxjs/toolkit/query/react';

import { apiSahReports } from '~constants/api';

import { rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';

import { DashboardColumnSpecsResponse } from '~support-at-home/models/dashboard';
import { AcfrItemsResponse } from '~support-at-home/models/acfrItems';

type Request = {
  date_from: string;
  date_to: string;
  limit: number;
  /** Omitted for the first page; afterwards the previous page's `next_cursor`. */
  cursor?: string;
};

export const sahAcfrItemsApi = createApi({
  reducerPath: 'sahAcfrItemsApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiSahReports }),
  tagTypes: ['sah-acfr-items'],
  endpoints: (builder) => ({
    getAcfrItems: builder.query<AcfrItemsResponse, Request>({
      query: (params) => ({
        url: '/acfr/items',
        method: 'GET',
        params,
      }),
      providesTags: [{ type: 'sah-acfr-items', id: 'LIST' }],
      transformResponse: (payload) => unwrap<AcfrItemsResponse>(payload),
    }),
    getAcfrItemsSpecs: builder.query<DashboardColumnSpecsResponse, void>({
      query: () => ({
        url: '/acfr/items',
        method: 'GET',
        params: { specs: true },
      }),
      providesTags: [{ type: 'sah-acfr-items', id: 'SPECS' }],
      transformResponse: (payload) => unwrap<DashboardColumnSpecsResponse>(payload),
    }),
  }),
});

export const { useLazyGetAcfrItemsQuery, useGetAcfrItemsSpecsQuery } = sahAcfrItemsApi;
